import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useATSAuth } from '../../context/ATSAuthContext';

const PageLoader = () => (
  <div className="min-h-screen bg-white flex items-center justify-center">
    <div className="flex flex-col items-center gap-4">
      <div className="relative">
        <div className="w-12 h-12 border-3 border-primary/20 rounded-full" />
        <div className="absolute top-0 left-0 w-12 h-12 border-3 border-cyan-500 border-t-transparent rounded-full animate-spin" />
      </div>
      <span className="text-slate-400 text-sm font-medium">Loading...</span>
    </div>
  </div>
);

export default function ATSProtectedRoute({ children }) {
  const { user, loading } = useATSAuth();
  const location = useLocation();

  if (loading) {
    return <PageLoader />;
  }

  if (!user) {
    return <Navigate to="/ats/login" state={{ from: location }} replace />;
  }

  return children;
}
